import React from 'react';
import clsx from 'clsx';
import { Popover } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ExpandMore } from '@mui/icons-material';
import { Button, ButtonProps } from '../Button';
import { useResizeObserver } from '../Layout';


const useStyles = makeStyles()(theme => ({
  button: {
    borderRadius: '4px',
    textTransform: 'none',
    transition: 'none',
  },
  opened: {
    borderWidth: '2px !important',
    borderColor: `${theme.palette.secondary.main} !important`,
    padding: '5px 15px',
  },
}));


export type DropdownFilterButtonProps = ButtonProps<'button'> & {
  label: React.ReactNode;
  open: boolean;
  setOpen: (value: boolean) => void;
};


export const DropdownFilterButton: React.FC<DropdownFilterButtonProps> = ({ label, children, open, setOpen, ...props }) => {
  const { classes } = useStyles();
  const anchorElRef = React.useRef<HTMLButtonElement>(null);
  const popoverActionsRef = React.useRef<{ updatePosition: () => void } | null>(null);
  const [ elementRef, setElementRef ] = React.useState<HTMLDivElement | null>(null);

  useResizeObserver(elementRef, () => {
    popoverActionsRef.current?.updatePosition?.();
  });

  return (
    <>
      <Button
        {...props}
        ref={anchorElRef}
        variant="outlined"
        endIcon={<ExpandMore />}
        className={clsx(props.className, classes.button, {
          [classes.opened]: open,
        })}
        onClick={() => setOpen(true)}
      >
        {label}
      </Button>
      <Popover
        open={open}
        action={popoverActionsRef}
        onClose={() => setOpen(false)}
        anchorEl={anchorElRef.current}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            style: {
              marginTop: 4,
            },
          },
        }}
      >
        <div ref={setElementRef}>
          {children}
        </div>
      </Popover>
    </>
  );
};


